import { render } from "./VideoElement.vue?vue&type=template&id=28b86a86&scoped=true"
import script from "./VideoElement.vue?vue&type=script&lang=js"
export * from "./VideoElement.vue?vue&type=script&lang=js"

import "./VideoElement.vue?vue&type=style&index=0&id=28b86a86&scoped=true&lang=scss"
import "./VideoElement.vue?vue&type=style&index=1&id=28b86a86&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28b86a86"]])

export default __exports__